import { useCallback } from 'react'

import { Divider, ChevronDownIcon, Text } from '@cash-me/react-components'
import NextLink from 'next/link'
import { useRouter } from 'next/router'

import { AnchorButton } from 'components/anchor-button'
import { Popper } from 'components/popper'
import { pushDataLayer } from 'utils/push-data-layer'

import * as S from './styles'

export const Topbar = () => {
  const router = useRouter()
  const { asPath } = router
  const urlPartner = asPath.includes('/condo/')
    ? process.env.NEXT_PUBLIC_CONDO_URL
    : process.env.NEXT_PUBLIC_PARTNER_URL

  const handleDataLayer = useCallback((section: string, name: string) => {
    pushDataLayer({
      category: 'Clique',
      action: 'Header',
      label: `${section} - Link ${name}`
    })
  }, [])

  return (
    <S.Wrapper>
      <Popper>
        <S.Trigger>
          <Text size="body2" weight="bold">
            Para você
          </Text>
          <ChevronDownIcon color="var(--colors-blue-icon-default)" size={24} />
        </S.Trigger>
        <S.Dropdown>
          <li>
            <NextLink
              href="/emprestimo-com-garantia-de-imovel"
              onClick={() => {
                handleDataLayer('Para você', 'Empréstimo com Garantia de Imóvel')
              }}
              className="ds-link"
            >
              Empréstimo com Garantia de Imóvel
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/financiamento-para-construcao"
              onClick={() => {
                handleDataLayer('Para você', 'Financiamento para Construção')
              }}
              className="ds-link"
            >
              Financiamento para Construção
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/financiamento-imobiliario"
              onClick={() => {
                handleDataLayer('Para você', 'Financiamento Imobiliário')
              }}
              className="ds-link"
            >
              Financiamento Imobiliário (SFI)
            </NextLink>
          </li>
        </S.Dropdown>
      </Popper>
      <Popper>
        <S.Trigger>
          <Text size="body2" weight="bold">
            Para seu negócio
          </Text>
          <ChevronDownIcon color="var(--colors-blue-icon-default)" size={24} />
        </S.Trigger>
        <S.Dropdown>
          <li>
            <NextLink
              href="/emprestimo-com-garantia-de-imovel"
              onClick={() => {
                handleDataLayer('Para seu negócio', 'Empréstimo com Garantia de Imóvel')
              }}
              className="ds-link"
            >
              Empréstimo com Garantia de Imóvel
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/emprestimo-para-empresa"
              onClick={() => {
                handleDataLayer('Para seu negócio', 'Empréstimo para Empresa')
              }}
              className="ds-link"
            >
              Empréstimo para Empresas
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/emprestimo-para-capital-de-giro"
              onClick={() => {
                handleDataLayer('Para seu negócio', 'Empréstimo para Capital de Giro')
              }}
              className="ds-link"
            >
              Empréstimo para Capital de Giro
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/financiamento-para-construcao"
              onClick={() => {
                handleDataLayer('Para seu negócio', 'Financiamento para Construção')
              }}
              className="ds-link"
            >
              Financiamento para Construção
            </NextLink>
          </li>
        </S.Dropdown>
      </Popper>
      <Popper>
        <S.Trigger>
          <Text size="body2" weight="bold">
            Para seu condomínio
          </Text>
          <ChevronDownIcon color="var(--colors-blue-icon-default)" size={24} />
        </S.Trigger>
        <S.Dropdown>
          <li>
            <NextLink
              href="/condo"
              onClick={() => {
                handleDataLayer('Para seu condomínio', 'Empréstimo para condomínio')
              }}
              className="ds-link"
            >
              Empréstimo para Condomínio
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/financiamento-energia-solar"
              onClick={() => {
                handleDataLayer('Para seu condomínio', 'Financiamento para Energia Solar')
              }}
              className="ds-link"
            >
              Financiamento para Energia Solar
            </NextLink>
          </li>
        </S.Dropdown>
      </Popper>
      <Popper>
        <S.Trigger>
          <Text size="body2" weight="bold">
            A CashMe
          </Text>
          <ChevronDownIcon color="var(--colors-blue-icon-default)" size={24} />
        </S.Trigger>
        <S.Dropdown>
          <li>
            <NextLink
              href="/quem-somos"
              onClick={() => {
                handleDataLayer('A CashMe', 'Sobre a CashMe')
              }}
              className="ds-link"
            >
              Sobre a CashMe
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/fale-conosco"
              onClick={() => {
                handleDataLayer('A CashMe', 'Fale Conosco')
              }}
              className="ds-link"
            >
              Fale Conosco
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/programa-de-integridade"
              onClick={() => {
                handleDataLayer('A CashMe', 'Programa de Integridade')
              }}
              className="ds-link"
            >
              Programa de Integridade
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="/seguranca"
              onClick={() => {
                handleDataLayer('A CashMe', 'Dicas de Segurança')
              }}
              className="ds-link"
            >
              Dicas de Segurança
            </NextLink>
          </li>
          <Divider />
          <li>
            <NextLink
              href="https://www.cashme.com.br/blog/"
              onClick={() => {
                handleDataLayer('A CashMe', 'Blog')
              }}
              className="ds-link"
            >
              Blog CashMe
            </NextLink>
          </li>
        </S.Dropdown>
      </Popper>
      <NextLink
        href="/seja-um-parceiro"
        onClick={() => {
          handleDataLayer('Seja parceiro', 'Seja parceiro')
        }}
        className="ds-link"
      >
        <Text size="body2" weight="bold" color="var(--colors-neutral-text-default)">
          Seja parceiro
        </Text>
      </NextLink>
      <Divider type="vertical" />
      <AnchorButton
        href="/sou-cliente/"
        size="sm"
        dataLayer={{
          category: 'Clique',
          action: 'Header',
          label: 'Sou cliente - Link Sou cliente'
        }}
      >
        Sou cliente
      </AnchorButton>
      <AnchorButton
        href={urlPartner!}
        size="sm"
        color="white"
        dataLayer={{
          category: 'Clique',
          action: 'Header',
          label: 'Sou parceiro - Link Sou parceiro'
        }}
      >
        Sou parceiro
      </AnchorButton>
    </S.Wrapper>
  )
}
